import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { authService } from "@/api/auth.service";
import { userService } from "@/api/user.service";
import type { User } from "@/api/types";

interface AuthCtx { user: User | null; token: string | null; loading: boolean; login: (e: string, p: string) => Promise<void>; register: (n: string, e: string, p: string) => Promise<void>; logout: () => void; refreshUser: () => Promise<void>; }
const AuthContext = createContext<AuthCtx | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) { userService.getMe().then(setUser).catch(logout).finally(() => setLoading(false)); }
    else setLoading(false);
  }, []);

  const handleAuth = async (data: { user: User; token: string }) => {
    localStorage.setItem("token", data.token);
    setToken(data.token);
    const fullUser = await userService.getMe();
    setUser(fullUser);
  };
  const login = async (email: string, password: string) => handleAuth(await authService.login({ email, password }));
  const register = async (name: string, email: string, password: string) => handleAuth(await authService.register({ name, email, password }));
  const logout = () => { localStorage.removeItem("token"); setToken(null); setUser(null); };
  const refreshUser = async () => setUser(await userService.getMe());

  return <AuthContext.Provider value={{ user, token, loading, login, register, logout, refreshUser }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
